import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalBody, Form, FormGroup, Label, Input } from "reactstrap";
import { Calendar } from "react-date-range";
import "react-calendar-timeline/lib/Timeline.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB, srLatn } from "date-fns/locale";
import { format } from "date-fns";
import { useLocation } from 'react-router-dom';
//import "./modals.css"
import apiRequest from "../../api";

const EditModal = ({
    isOpen,
    toggle,
    selectedRow,
    fetchReservations
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'EN';
    });
    useEffect(() => {
        setSelectedLanguage(localStorage.getItem('Language') || 'EN');
    }, [isOpen]);
    const locale = selectedLanguage === 'RS' ? srLatn : enGB;
    const calendarRef = useRef(null);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const { pathname } = useLocation()
    const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };
    const isCurrentTimeBetween = (startTime, endTime) => {
        const now = new Date();

        // Parse startTime and endTime
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        const [endHours, endMinutes] = endTime.split(':').map(Number);

        // Create Date objects for start and end times
        const startDate = new Date();
        startDate.setHours(startHours, startMinutes, 0, 0);

        const endDate = new Date();
        endDate.setHours(endHours, endMinutes, 0, 0);

        // Compare current time with start and end times
        if (startDate <= endDate) {
            // Normal range (same day)
            return now >= startDate && now <= endDate;
        } else {
            // Range spans midnight
            return now >= startDate || now <= endDate;
        }
    };
    const [formDetails, setFormDetails] = useState({
        date: selectedRow.start_time,
        start: formatTime(selectedRow.start_time),
        end: formatTime(selectedRow.end_time),
        name: selectedRow.name,
        username: selectedRow.username,
        company: selectedRow.company,
        id: selectedRow.id,
        notes: selectedRow.notes,
    });
    const [errors, setErrors] = useState({
        start: "",
        end: "",
        name: "",
        company: "",
        message: "",
    });



    const toggleModal = (date) => {

        setErrors({
            start: "",
            end: "",
            name: "",
            company: "",
            message: "",
        });
        setFormDetails({
            date: selectedRow.start_time,
            start: formatTime(selectedRow.start_time),
            end: formatTime(selectedRow.end_time),
            name: selectedRow.name,
            username: selectedRow.username,
            company: selectedRow.company,
            id: selectedRow.id,
            notes: selectedRow.notes,
        });
        toggle();
    };
    useEffect(() => {
        setFormDetails({
            date: selectedRow.start_time,
            start: formatTime(selectedRow.start_time),
            end: formatTime(selectedRow.end_time),
            name: selectedRow.name,
            username: selectedRow.username,
            company: selectedRow.company,
            id: selectedRow.id,
            notes: selectedRow.notes,
        });
    }, [selectedRow]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        // Convert the form details
        const formattedDate = format(formDetails.date, "yyyy-MM-dd"); // Format the date to YYYY-MM-DD
        const startTime = `${formDetails.start}:00`; // Append ':00' to start time
        const endTime = `${formDetails.end}:00`; // Append ':00' to end time
        const name = formDetails.name; // No change needed for name
        const company = formDetails.company; // No change needed for company

        const newErrors = {
            start: formDetails.start === "" ? "This field is required" : "",
            end: formDetails.end === "" ? "This field is required" : "",
            name: formDetails.name === "" ? "This field is required" : "",
            company: formDetails.company === "" ? "This field is required" : "",
        };
        setErrors({
            ...errors,
            ...newErrors
        });

        if (newErrors.start || newErrors.end || newErrors.name || newErrors.company) {
            return;
        }
        // Create the request body
        const requestBody = {
            reservationCode: formDetails.id,
            date: formattedDate,
            startTime: startTime,
            endTime: endTime,
            name: name,
            company: company,
            notes: formDetails.notes,
        };

        // Make the POST request
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const response = await apiRequest('/api/reservations/editReservation', 'POST', requestBody, token);

            // Handle the response
            console.log("Reservation created successfully:", response);
            fetchReservations();
            toggleModal(); // Close the modal after successful submission

        } catch (error) {
            try {
                // Parse the error message
                const errorData = JSON.parse(error.message);

                // Check if the body contains the error and starts with the desired text
                if (errorData.Body?.error?.includes("no available parking")) {
                    setErrors({
                        start: "",
                        end: "",
                        name: "",
                        message: selectedLanguage === "EN" ? "No available parking for selected time" : "Nema slobodnog parking mesta za izabrani termin"
                    });
                }
                else {
                    alert(error);
                }
            } catch (parseError) {
                console.error("Failed to parse error message:", parseError);
            }
        }
    };

    const handleInputChange = (e, field) => {
        const { name, value } = e.target;

        if (field === "end" || field === "start") {
            formDetails[name] = value;
        } else {
            formDetails[name] = value;
        }

        setFormDetails({ ...formDetails });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) // Check if click is outside
            ) {
                setIsCalendarOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (
        <Modal isOpen={isOpen} toggle={toggleModal} centered className="custom-model">
            <ModalBody className="modal-content" style={{ backgroundColor: "#f5f5f5" }}>
                <Form>
                    {(pathname.includes("security") || pathname.includes("admin")) && (
                        <div className="row justify-content-center pt-2 mb-2">
                            <div className="col-md-6">
                                <FormGroup>
                                    <Label className="w-10 label">{selectedLanguage === "EN" ? "User:" : "Korisnik:"}</Label>
                                    <Label className="w-50 text-center label">
                                        {formDetails.username}
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>
                    )}
                    <div className="row justify-content-center mb-2" ref={calendarRef} >
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Date" : "Datum"} <sup className="text-danger">*</sup>
                                </Label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={format(formDetails.date, "dd.MM.yyyy")}
                                    onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                    readOnly
                                    style={{ cursor: "pointer", borderRadius: 5 }}
                                />
                                <div className="calendar-container">
                                    {isCalendarOpen && (
                                        <Calendar
                                            date={formDetails.date}
                                            onChange={(date) => {
                                                setFormDetails((prevDetails) => ({
                                                    ...prevDetails,
                                                    date: date, // Update the date
                                                }));
                                                setIsCalendarOpen(false);
                                            }}
                                            locale={locale}
                                            color="#3d91ff"
                                            className="calendar-container"
                                        />
                                    )}
                                </div>
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Start" : "Početak"} <sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="time"
                                    name="start"
                                    value={formDetails.start}
                                    onChange={handleInputChange}
                                    className={`form-control text-center ${errors.start ? "input-error" : ""}`}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "End" : "Kraj"} <sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="time"
                                    name="end"
                                    value={formDetails.end}
                                    onChange={handleInputChange}
                                    className={`form-control text-center ${errors.end ? "input-error" : ""}`}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Guest's Name" : "Ime Gosta"}<sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={formDetails.name}
                                    onChange={handleInputChange}
                                    className={errors.name ? "input-error" : ""}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Guest's Company" : "Kompanija Gosta"}<sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="text"
                                    name="company"
                                    value={formDetails.company}
                                    onChange={handleInputChange}
                                    className={errors.company ? "input-error" : ""}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center mb-2">
                        <div className="col-12">
                            <FormGroup>
                                <Label>{selectedLanguage === "EN" ? "Note" : "Napomena"}</Label>
                                <textarea
                                    name="notes"
                                    className="form-control input-left"
                                    value={formDetails.notes}
                                    onChange={handleInputChange}
                                    rows="2"
                                    cols="50"
                                    placeholder={selectedLanguage === "EN"
                                        ? "License plate number (preferred)"
                                        : "Registarske tablice (poželjno)"}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    {errors.message && (
                        <div className="mb-3"
                            style={{
                                fontSize: "16px",
                                fontFamily: "jura-light",       // Text color
                                textAlign: "center",
                                color: "red",  // Centers the text horizontally
                            }}>
                            {errors.message}
                        </div>
                    )}

                    {(pathname.includes("security") || pathname.includes("admin")) && (isCurrentTimeBetween(formDetails.start, formDetails.end)) && (
                        <div className="row justify-content-center mb-2 ">
                            <div className="col-md-6 text-center">
                                <FormGroup>
                                    <button className=" model-btn btn btn-primary rounded-2 py-1 px-5" type="button" onClick={() => {
                                        setFormDetails({
                                            ...formDetails,
                                            end: formatTime(new Date()),
                                        });
                                    }}>
                                        Stop
                                    </button>
                                </FormGroup>
                            </div>
                        </div>
                    )}

                    <FormGroup>
                        <div className="row">
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                                    onClick={toggleModal}
                                    type="button"
                                >
                                    {selectedLanguage === "EN" ? "Cancel" : "Otkaži"}
                                </button>
                            </div>
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn btn btn-primary rounded-2 py-1 px-5"
                                    onClick={handleSubmit}
                                >
                                    {selectedLanguage === "EN" ? "Apply" : "Primeni"}
                                </button>
                            </div>
                        </div>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default EditModal;
